/**
 * @license
 * Copyright 2022 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */

import {FFT, FFTInputs, KernelConfig, TensorInfo} from '@tensorflow/tfjs-core';

import {WebGPUBackend} from '../backend_webgpu';

import {fftImpl} from './FFT_impl';

export function fft(args: {inputs: FFTInputs, backend: WebGPUBackend}):
    TensorInfo {
  const {inputs, backend} = args;
  const {input} = inputs;

  return fftImpl(input, false /* inverse */, backend);
}

export const fftConfig: KernelConfig = {
  kernelName: FFT,
  backendName: 'webgpu',
  kernelFunc: fft
};
